import React, { useEffect, cloneElement, Fragment } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLearningDataAction } from "../../../../redux/learningData";
import { loadInitialQuestionAction, clearAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { clearAnsweringInfoAction } from "../../../../redux/answeringQuestions/answeringInfo";
import { clearTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import { clearQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import Logger from "./Logger";
import Closer from "./Closer";
import QuestionCountAccentor from "./QuestionCountAccentor";
import Timer from "./Timer";
import Viewer from "./Viewer";
import QuestionTipHider from "./QuestionTipHider";
import CorrectAnswerDevelop from "./CorrectAnswerDevelop";
import ScribbleCleaner from "./ScribbleCleaner";
import ScribbleErase from "./ScribbleErase";
import GrammarReducer from "./GrammarReducer";
import Scribbler from "./Scribbler";
import KeypadShower from "./KeypadShower";
import Inputer from "./Inputer";
import KeyPresser from "./KeyPresser";
import KeyClicker from "./KeyClicker";
import NoteTaker from "./NoteTaker";
import AnswerEditorController from "./AnswerEditorController";
import Submitter from "./Submitter";
import EntryPopupHider from "./EntryPopupHider";
import ScribbleTooltipHider from "./ScribbleTooltipHider";
import TimeOverPopupHider from "./TimeOverPopupHider";
import NotEnteredAnswerChecker from "./NotEnteredAnswerChecker";
import OXPopupHider from "./OXPopupHider";
import RelayWrongAnswerPopupHider from "./RelayWrongAnswerPopupHider";
import ConceptCheckPlayerHider from "./ConceptCheckPlayerHider";
import AIMessagePopupHider from "./AIMessagePopupHider";
import Jumper from "./Jumper";

const AnsweringQuestionsInitializer = ( props ) => {

  const location = useLocation();
  const params = useParams();

  const dispatch = useDispatch();
  const setLearningData = payload => { dispatch( setLearningDataAction( payload ) ) };
  const loadInitialQuestion = payload => { dispatch( loadInitialQuestionAction( payload ) ) };
  const clearAnsweringQuestions = () => { dispatch( clearAnsweringQuestionsAction() ) };
  const clearAnsweringInfo = () => { dispatch( clearAnsweringInfoAction() ) };
  const clearTimeCount = () => { dispatch( clearTimeCountAction() ) };
  const clearQuestionView = () => { dispatch( clearQuestionViewAction() ) };
  // const { setHackleInfo, clearHackleInfo } = useHackleInfo();
  
  useEffect( () => {
    setTimeout( () => {
      setLearningData( { answeringQuestionsComplete : false } );
      loadInitialQuestion( {
        learningType : params.learningType,
        learningEntryType : location.state?.learningEntryType,
        stageCode : params.stageCode,
        resumeYn : location.state?.resumeYn
      } );
    } );
    return () => {
      clearAnsweringQuestions();
      clearAnsweringInfo();
      clearTimeCount();
      clearQuestionView();
    };
  }, [] );

  return cloneElement( props.children || <Fragment />, {
    Logger,
    Closer,
    QuestionCountAccentor,
    Timer,
    Viewer,
    QuestionTipHider,
    CorrectAnswerDevelop,
    ScribbleCleaner,
    ScribbleErase,
    GrammarReducer,
    Scribbler,
    KeypadShower,
    Inputer,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    EntryPopupHider,
    ScribbleTooltipHider,
    TimeOverPopupHider,
    NotEnteredAnswerChecker,
    OXPopupHider,
    RelayWrongAnswerPopupHider,
    ConceptCheckPlayerHider,
    AIMessagePopupHider,
    Jumper
  } );

};

export default AnsweringQuestionsInitializer;
